// frontend/src/services/PositionService.js
import axios from 'axios';

class PositionService {
  updatePosition(positionId, data, accessToken) {
    return axios.put(
      `${process.env.REACT_APP_API_URL}/api/positions/${positionId}`,
      data,
      {
        headers: {
          'Authorization': `Bearer ${accessToken}`
        }
      }
    ).then(r => r.data);
  }

  createPosition(data, accessToken) {
    return axios.post(
      `${process.env.REACT_APP_API_URL}/api/periods/${data.period_id}/positions`,
      { x: data.x, y: data.y },
      {
        headers: {
          'Authorization': `Bearer ${accessToken}`
        }
      }
    ).then(r => r.data);
  }

  deletePosition(positionId, accessToken) {
    return axios.delete(
      `${process.env.REACT_APP_API_URL}/api/positions/${positionId}`,
      {
        headers: {
          'Authorization': `Bearer ${accessToken}`
        }
      }
    ).then(r => r.data);
  }

  associateSkill(sessionId, positionId, skillId) {
    return axios.post(
      `${process.env.REACT_APP_API_URL}/sessions/${sessionId}/positions/${positionId}/skills/${skillId}`
    );
  }

  removeSkill(sessionId, positionId, skillId) {
    return axios.delete(
      `${process.env.REACT_APP_API_URL}/sessions/${sessionId}/positions/${positionId}/skills/${skillId}`
    );
  }

  associateStunt(sessionId, positionId, stuntId) {
    return axios.post(
      `${process.env.REACT_APP_API_URL}/sessions/${sessionId}/positions/${positionId}/stunts/${stuntId}`
    );
  }

  removeStunt(sessionId, positionId, stuntId) {
    return axios.delete(
      `${process.env.REACT_APP_API_URL}/sessions/${sessionId}/positions/${positionId}/stunts/${stuntId}`
    );
  }
}

export default new PositionService();
